import { RequestQueueManager } from '@whistler-ui/k2/helpers';
import { SilentParam } from '@whistler-ui/k2/types/common';

import {
  CarrierDocsResponse,
  ResourceByTypeResponse,
} from '../types/resources';
import { requestWithOptions, requestWithOptionsNoAuth } from './helper';

const basePath = import.meta.env.REACT_APP_API_ENDPOINT_RESOURCES || '/';

const requestQueueInstance = new RequestQueueManager();

export const handleGetResourceByType = type => () => {
  try {
    const id = requestQueueInstance.enqueueProcess(() =>
      getResourcesByType(type),
    );
    return requestQueueInstance.waitForProcessCompletion(id);
  } catch (error) {
    return error;
  }
};

export const getResourcesByType = async ({
  type,
  silent,
}: { type: string } & Partial<SilentParam>) => {
  try {
    const options = { method: 'GET' };
    const path = `${basePath}/resources/${type}`;

    const response = await requestWithOptionsNoAuth(path, options);
    return response as ResourceByTypeResponse[];
  } catch (error) {
    const errorMsg = (error as Error | TypeError).message;
    console.error(errorMsg);

    if (silent) {
      return null;
    }

    throw error;
  }
};

export const getCarrierDocs = async ({
  paths,
  silent,
}: { paths: string[] } & Partial<SilentParam>) => {
  try {
    const response = await requestWithOptions(`${basePath}/api_spec/${paths}`, {
      method: 'GET',
    });

    return response as CarrierDocsResponse;
  } catch (error) {
    if (paths.length === 0 || silent) {
      return null;
    }

    throw error;
  }
};

export const getInboundDocs = async ({
  paths,
  silent,
}: { paths: string[] } & Partial<SilentParam>) => {
  try {
    const response = await requestWithOptions(
      `${basePath}/api_spec_inbound/${paths}`,
      {
        method: 'GET',
      },
    );

    return response as CarrierDocsResponse;
  } catch (error) {
    if (paths.length === 0 || silent) {
      return null;
    }

    throw error;
  }
};
